import { AppState } from '../../../../redux/reducers';
import * as Store from '../../../../redux/middleware/ContractConceptCategoryMiddleware';
import { ContractConceptCategory } from '../../../../models/Entities/Contracts/ContractConceptCategory';
import { ErrorType } from '../../../../models/HttpError';

export interface IProps {
    isOpen: boolean;
    onClose: () => void;
}

interface ConnectedProps {
    Categories: ContractConceptCategory[];
    isLoading: boolean;
    hasLoaded: boolean;
    failOnLoading: boolean;
    isSaving: boolean;
    savedOk: boolean | undefined;
    failOnSaving: boolean;
    isDeleting: boolean;
    deletingId: number | undefined;
    deletedOk: boolean | undefined;
    failOnDeleting: boolean;
    error: ErrorType | undefined;
}

interface DispatchProps {
    GetAllContractConceptCategories: typeof Store.actionCreators.GetAllContractConceptCategories;
    AddContractConceptCategory: typeof Store.actionCreators.AddContractConceptCategory;
    UpdateContractConceptCategory: typeof Store.actionCreators.UpdateContractConceptCategory;
    DeleteContractConceptCategory: typeof Store.actionCreators.DeleteContractConceptCategory;
    ResetContractConceptCategoryFlags: typeof Store.actionCreators.ResetContractConceptCategoryFlags;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState): ConnectedProps => {
    const s = state.ContractConceptCategories;
    return {
        Categories: s?.list ?? [],
        isLoading: s?.isLoadingAll ?? false,
        hasLoaded: s?.successLoadingAll !== undefined || !!s?.failOnLoadingAll,
        failOnLoading: s?.failOnLoadingAll ?? false,
        isSaving: !!(s?.isAddingNewOne || s?.isUpdatingOne),
        savedOk: s?.successAddingNewOne || s?.successUpdatingOne,
        failOnSaving: !!(s?.failOnAddingNewOne || s?.failOnUpdatingOne),
        isDeleting: s?.isDeletingOne ?? false,
        deletingId: s?.deletingId,
        deletedOk: s?.successDeletingOne,
        failOnDeleting: s?.failOnDeletingOne ?? false,
        error: s?.error
    };
};

export const mapDispatchToProps = { ...Store.actionCreators };
